import { Show } from 'solid-js';
import { updateAvailable, applyUpdate } from '../lib/version.js';

// Shown when the server reports a different version than this running bundle and
// auto-update didn't (or shouldn't) reload — e.g. a new version deployed while
// the app was already open. A tap reloads into the new version.
export default function UpdateBanner() {
  return (
    <Show when={updateAvailable()}>
      <div class="pwa-update">
        <span>Versi baru aplikasi tersedia.</span>
        <button class="pwa-update-btn" onClick={applyUpdate}>Muat ulang</button>
      </div>
    </Show>
  );
}
